import { useContext } from "@nuxtjs/composition-api";

export function useTaskPriceFormatters() {
  const { i18n } = useContext();

  function formatTaskPrice(price, includeUnit = true) {
    const isFromTo = !!(
      price.priceFrom &&
      price.priceTo &&
      price.priceFrom !== price.priceTo
    );

    const value = isFromTo
      ? `${i18n.n(price.priceFrom, price.priceType)} - ${i18n.n(
          price.priceTo,
          price.priceType
        )}`
      : i18n.n(price.price, price.priceType);

    if (includeUnit) {
      const unit = price?.priceTag?.unit ?? price.professionTask?.unit;

      if (!unit) {
        return value;
      }

      return `${value} / ${unit}`;
    }

    return value;
  }

  return {
    formatTaskPrice,
  };
}
